import { Component, OnInit } from "@angular/core";
import { OrderService } from "src/app/core/services/order.service";
import { OOVenueService } from "src/app/core/services/venue-service";

@Component({
	selector: "app-check-out-tip-select",
	templateUrl: "./check-out-tip-select.component.html",
	styleUrls: ["../../online-order.component.scss"],
})
export class CheckOutTipSelectComponent implements OnInit {
	constructor(public orderService: OrderService, public venueService: OOVenueService) {}

	ngOnInit(): void {}
}
